function parseQueryParams() {
  const paramStrings = window.location.search.substring(1).split(`&`);
  const params = {};
  for (let i = 0; i < paramStrings.length; ++i) {
    const kv = paramStrings[i].split(`=`);
    params[decodeURIComponent(kv[0])] = decodeURIComponent(kv[1]);
  }
  return params;
}

export function getFtProperties() {
  let properties = {};
  const params = parseQueryParams();

  // This logic was initially written to use register_once/set_once.
  // addProperties allows us to keep the existing "first match wins" semantics.
  function addProperties(obj) {
    properties = Object.assign({}, obj, properties);
  }

  // First, we check if user was CPC
  if (params.utm_medium === `cpc`) {
    // if present, set other FT properties according to utm params. However, if
    // not present, set to NONE (so that it doesn't pick it up on a future
    // campaign)
    addProperties({
      FT_MEDIUM: `CPC`,
      FT_SOURCE: params.utm_source || `None`,
      FT_CAMPAIGN: params.utm_campaign || `None`,
      FT_CONTENT: params.utm_content || `None`,
      FT_TERM: params.utm_term || `None`,
    });
  }

  // Second, we check if they were a Social or Search referral
  if (document.referrer.search(`https?://(.*)google.([^/?]*)`) === 0) {
    addProperties({FT_MEDIUM: `SEARCH`, FT_SOURCE: `Google`});
  } else if (document.referrer.search(`https?://(.*)bing.([^/?]*)`) === 0) {
    addProperties({FT_MEDIUM: `SEARCH`, FT_SOURCE: `Bing`});
  } else if (document.referrer.search(`https?://(.*)baidu.([^/?]*)`) === 0) {
    addProperties({FT_MEDIUM: `SEARCH`, FT_SOURCE: `Baidu`});
  } else if (document.referrer.search(`https?://(.*)aol.([^/?]*)`) === 0) {
    addProperties({FT_MEDIUM: `SEARCH`, FT_SOURCE: `AOL`});
  } else if (document.referrer.search(`https?://(.*)yahoo.([^/?]*)`) === 0) {
    addProperties({FT_MEDIUM: `SEARCH`, FT_SOURCE: `Yahoo`});
  } else if (document.referrer.search(`https?://(.*)ask.([^/?]*)`) === 0) {
    addProperties({FT_MEDIUM: `SEARCH`, FT_SOURCE: `Ask`});
  } else if (document.referrer.search(`https?://(.*)duckduckgo.([^/?]*)`) === 0) {
    addProperties({FT_MEDIUM: `SEARCH`, FT_SOURCE: `duckduckgo`});
  } else if (document.referrer.search(`https?://(.*)facebook.([^/?]*)`) === 0) {
    addProperties({FT_MEDIUM: `SOCIAL`, FT_SOURCE: `Facebook`});
  } else if (document.referrer.search(`https?://(.*)twitter.([^/?]*)`) === 0) {
    addProperties({FT_MEDIUM: `SOCIAL`, FT_SOURCE: `Twitter`});
  } else if (document.referrer.search(`https?://(.*)instagram.([^/?]*)`) === 0) {
    addProperties({FT_MEDIUM: `SOCIAL`, FT_SOURCE: `Instagram`});
  } else if (document.referrer.search(`https?://(.*)linkedin.([^/?]*)`) === 0) {
    addProperties({FT_MEDIUM: `SOCIAL`, FT_SOURCE: `LinkedIn`});
  }

  // Third, we check if they were another referral
  if (document.referrer) {
    // follow how our JS SDK does it http://bit.ly/2sWdliq
    addProperties({
      FT_MEDIUM: `REFERRAL`,
      FT_SOURCE: document.referrer.split(`/`)[2],
    });
  }

  // Fourth, we check if they were invited
  // checks to see if user clicked on invite link with following URL:
  // https://mixpanel.com/register/?email=[...]&next=/projects/accept-invite/[...]
  if (window.location.href.indexOf(`accept-invite`) !== -1) {
    addProperties({FT_MEDIUM: `INVITED`});
  }

  // Finally, if document.referrer is undefined, they are $direct
  addProperties({
    FT_MEDIUM: `$direct`,
    FT_SOURCE: `$direct`,
  });

  // Certain FT props only specific to CPC, so use this function to default to
  // None for other referral sources
  addProperties({
    FT_CAMPAIGN: `None`,
    FT_CONTENT: `None`,
    FT_TERM: `None`,
  });

  // If present, ref_id will be the distinct_id of the referring user.
  if (params.ref_id) {
    addProperties({'Referred By': params.ref_id});
  }

  return properties;
}
